import {JSONFlattener} from "../Utils/General";

export const Actions={
    updateUser:(payload)=>(new JSONFlattener(payload).returnJSON()),
    setUnreadCount:(payload)=>({unread:payload})
}


